import Vue from 'vue'
import App from './App.vue'

import 'vue-datetime/dist/vue-datetime.css'
import { Datetime } from 'vue-datetime'
Vue.use(Datetime)
Vue.component('datetime', Datetime)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
